import {API} from "@/Composables/api";

const getGroups = async (params = {}) => {
    return API.get(route("admin.groups.index"), params);
};

const getGroup = async (group) => {
    return API.get(route("admin.groups.show", group));
};

const getMemberGroups = async (user, params = {}) => {
    return API.get(route("admin.users.groups.index.member", user), params);
};

const getNonMemberGroups = async (user, params = {}) => {
    return API.get(route("admin.users.groups.index.non-member", user), params);
};

const storeGroup = async (group, params = {}) => {
    return API.post(route("admin.groups.store"), params, group);
};

const updateGroup = async (group, params = {}) => {
    return API.put(route("admin.groups.update", group), params, group);
};

const deleteGroup = async (groupId: number, params = {}) => {
    return API.delete(route("admin.groups.destroy", groupId), params);
};

const clearGroupAnsweredCounts = async (
    groupIds: string | number | Array<string | number> | null = null,
    params = {},
) => {
    const groupIdsPayload = Array.isArray(groupIds) ? groupIds : groupIds ? [groupIds] : [];

    return API.post(route("admin.groups.clear-answered-counts"), params, {
        groupIds: groupIdsPayload,
    });
};

export {
    getGroups,
    getGroup,
    getMemberGroups,
    getNonMemberGroups,
    storeGroup,
    updateGroup,
    deleteGroup,
    clearGroupAnsweredCounts,
};
